module.exports = __webpack_public_path__ + "static/nz-offroader-0efcb80c84d701f9e3c345f8396ae3a4.png";